<template>
  <!--
      	作者：kmdshop
      	时间：2019-06-04
      	描述：插件中心-ICP-历史查询
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form :inline="true" :model="formData" class="demo-form-inline">
        <el-form-item label="域名">
          <el-input v-model="formData.query_string" placeholder="请输入历史查询站点"></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker v-model="timeInterval" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitLoading" type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="common-level-rail">

    </div>
    <div class="product-content">
      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="icp_record_id" label="ID" width="180"></el-table-column>
        <el-table-column prop="query_string" label="查询" width="180"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status > 0 ? 'success' : 'danger'" effect="plain">
              {{ scope.row.status > 0 ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="查询时间"></el-table-column>
      </el-table>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import IcpApi from '@/api/icp.js'
  export default {
    data() {
      return {
        formData: {
          // query_string: '',
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        timeInterval: '',
        /*是否加载完成*/
        loading: true,
        submitLoading: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        tableData: [],
      };
    },
    created() {
      this.getData()
    },
    methods: {
      getData() {
        let self = this;
        let data = {
          'query_string': self.formData.query_string,
          'timeInterval': self.timeInterval
        }
        data.page = self.curPage;
        data.list_rows = self.pageSize;
        IcpApi.getRecordList(data, true)
          .then(data => {
            self.loading = false
            self.submitLoading = false
            self.tableData = data.data.res.data
            self.totalDataNumber = data.data.res.total
          })
          .catch(error => {})
      },
      onSubmit() {
        this.submitLoading = true
        this.loading = true
        this.getData()
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1
        this.pageSize = val
        this.loading = true
        this.submitLoading = true
        this.getData()
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this
        self.curPage = val
        self.loading = true
        self.submitLoading = true
        self.getData()
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/icp/icp/history.vue